import React from 'react';
import { useTranslation } from 'react-i18next';
import TableLabel from '../TableLabel';

const TableHeader = () => {
  const { t, ready } = useTranslation(['tableHeaderTitle', 'history']);

  if (!ready) {
    return <div>Carregando tradução...</div>;
  }

  const titles = t('title', { returnObjects: true }) as Array<string>;

  const isArrayTitles = Array.isArray(titles);

  return (
    <tr className="table-beneficiaries-header" data-testid="test-table-header">
      {isArrayTitles &&
        titles.map((item) => (
          <th key={item}>
            <TableLabel title={item} />
          </th>
        ))}
    </tr>
  );
};

export default TableHeader;
